"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecentSpend = exports.getFutureTxnsForAccountIds = exports.getFutureTxnsForAccountIdsHelper = exports.filterFutureOrDueOverdue = exports.padBounds = exports.calcRunningBalances = void 0;
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const transactions_1 = require("companion-app-components/flux/transactions");
const utils_1 = require("utils/utils");
const utils_2 = require("data/transactions/utils");
const memoizeWithKey_1 = require("utils/memoizeWithKey");
const objectToKeyUtils_1 = require("utils/objectToKeyUtils");
/*
 CALC RUNNING BALANCES
 */
function calcRunningBalances(txns, sortBy, sortOrder, endingBalance, isExcludePendingTxn) {
    if (sortBy !== 'date') {
        return txns;
    }
    let txnsWithBalances = [];
    let balance = endingBalance;
    const reverse = sortOrder === 'ascending';
    const parseList = reverse ? txns.reverse() : txns;
    parseList.forEach((txn) => {
        if ((isExcludePendingTxn && (0, utils_2.isBankOwnedPending)(txn)) || (0, utils_2.isC2RTransaction)(txn)) {
            txnsWithBalances.push(txn);
        }
        else {
            txnsWithBalances.push(txn.set('balance', balance));
            balance -= (0, utils_1.noNaN)(txn.amount);
        }
    });
    if (reverse) {
        txnsWithBalances = txnsWithBalances.reverse();
    }
    return (0, immutable_1.List)(txnsWithBalances);
}
exports.calcRunningBalances = calcRunningBalances;
function padBounds(balances) {
    const firstMin = Math.min(...balances) || 0;
    const firstMax = Math.max(...balances) || 100;
    const deviation = (firstMax - firstMin) || Math.abs(firstMax) / 4 || 100;
    let minBalance = firstMin;
    let maxBalance = firstMax;
    if (minBalance > 0) {
        minBalance -= (minBalance * 0.4);
    }
    else {
        minBalance -= (deviation * 0.2);
    }
    if (maxBalance > 0) {
        maxBalance += deviation * 0.3;
    }
    else {
        maxBalance -= (maxBalance * 0.4);
    }
    const minLimit = firstMin - deviation;
    if (minBalance < minLimit) {
        minBalance = minLimit;
    }
    const maxLimit = firstMax + deviation;
    if (maxBalance > maxLimit) {
        maxBalance = maxLimit;
    }
    return {
        min: minBalance,
        max: maxBalance,
        high: firstMax,
        low: firstMin,
    };
}
exports.padBounds = padBounds;
/*
 FILTER FUTURE OR DUE OVERDUE
*/
function filterFutureOrDueOverdue(txn) {
    const info = (0, utils_2.getTxnStateInfo)(txn);
    if (info.status === 'DUE' || info.status === 'OVERDUE') {
        return true;
    }
    const refundState = (0, utils_2.getRefundState)(txn);
    if (refundState === utils_2.RefundState.EXPECTED || refundState === utils_2.RefundState.OVERDUE) {
        return true;
    }
    return luxon_1.DateTime.fromISO(txn.postedOn).startOf('day') > luxon_1.DateTime.local().startOf('day');
}
exports.filterFutureOrDueOverdue = filterFutureOrDueOverdue;
const getFutureTxnsForAccountIdsHelper = (props) => {
    const { accountIdsList, accountsById, transactionsByAccountId, transactionsByAccountIdsSelectors, featureFlags, } = props;
    let txnList = (0, immutable_1.List)();
    let filteredTransactions;
    const filter = '';
    const sortBy = 'date';
    const sortOrder = 'ascending';
    accountIdsList.forEach((accountId) => {
        const acct = accountsById.get(accountId);
        if (acct && !(featureFlags.get('hideLoanTransactions') && acct.type === 'LOAN')) {
            const transactionsForAccountIdSelector = transactionsByAccountIdsSelectors.get(accountId);
            const transactionsForAccountId = transactionsForAccountIdSelector(transactionsByAccountId, {
                sortBy,
                sortOrder,
                filter,
            });
            filteredTransactions = transactionsForAccountId.filter((txn) => filterFutureOrDueOverdue(txn));
            txnList = txnList.concat(filteredTransactions);
        }
    });
    return txnList;
};
exports.getFutureTxnsForAccountIdsHelper = getFutureTxnsForAccountIdsHelper;
/*
  Get Future Transactions helper function
 */
const getFutureTxnsForAccountIds = (props) => {
    const { accountIdsList, accountsById, transactionsByAccountId, transactionsByAccountIdsSelectors, featureFlags, } = props;
    const key = (0, objectToKeyUtils_1.getOrCreateStringFromObject)('futureTxnsForAccountIds', {
        accountIdsList,
        accountsById,
        featureFlags,
        transactionsByAccountId,
        transactionsByAccountIdsSelectors,
    }, 5, memoizeWithKey_1.memoizeWithKeyRetrieveCache);
    return (0, memoizeWithKey_1.memoizeWithKey)('futureTxnsForAccountIds', () => (0, exports.getFutureTxnsForAccountIdsHelper)(props), key, 5);
};
exports.getFutureTxnsForAccountIds = getFutureTxnsForAccountIds;
const isRecentSpend = (txnList, categoriesById) => txnList.filter((txn) => {
    if (!transactions_1.transactionsUtils.isSplitTxn(txn) && txn.coa) { // ensure there is a coa regardless
        // returns if is matched scheduled txn or expense
        let cat = categoriesById.get(txn.coa.id);
        const coaType = txn.coa.type;
        if (!cat)
            cat = 'UNCATEGORIZED';
        if (txn.isExcludedFromReports) {
            return false;
        }
        if (typeof cat === 'object' &&
            (cat.type === 'EXPENSE' || 'UNCATEGORIZED') &&
            cat.type !== 'INCOME' &&
            coaType !== 'ACCOUNT' &&
            coaType !== 'BALANCE_ADJUSTMENT') {
            return !(txn.source && txn.source === 'SCHEDULED_TRANSACTION_PENDING');
        }
    }
    else {
        // Check twice in case is split and scheduled, who knows weirder things have happened
        return !(txn.source && txn.source === 'SCHEDULED_TRANSACTION_PENDING');
    }
    return false;
});
exports.isRecentSpend = isRecentSpend;
